var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "main-content" }, [
    _c(
      "div",
      [
        _c("pulse-loader", {
          staticClass: "text-center",
          attrs: { loading: _vm.loading, color: _vm.color },
        }),
      ],
      1
    ),
    _vm._v(" "),
    !_vm.loading
      ? _c("div", [
          _vm.isTaksToAction()
            ? _c(
                "div",
                { staticClass: "row" },
                _vm._l(_vm.tasks, function (taskSet, userId) {
                  return _c("div", { key: userId, staticClass: "col-md-12" }, [
                    taskSet.tasks.length
                      ? _c("div", { staticClass: "card" }, [
                          _c("div", { staticClass: "card-header" }, [
                            _c("h6", [_vm._v(_vm._s(taskSet.user.name))]),
                          ]),
                          _vm._v(" "),
                          _c("div", { staticClass: "card-body" }, [
                            _c("table", { staticClass: "table table-hover" }, [
                              _vm._m(0, true),
                              _vm._v(" "),
                              _c(
                                "tbody",
                                [
                                  _vm._l(taskSet.tasks, function (task, index) {
                                    return _vm._l(
                                      task.preps,
                                      function (prep, index2) {
                                        return _c("tr", [
                                          _c("td", [
                                            _vm._v(_vm._s(index2 + 1)),
                                          ]),
                                          _vm._v(" "),
                                          _c("td", [
                                            _vm._v(_vm._s(task.taskId)),
                                          ]),
                                          _vm._v(" "),
                                          _c("td", [_vm._v(_vm._s(prep.id))]),
                                          _vm._v(" "),
                                          _c("td", [_vm._v(_vm._s(prep.name))]),
                                          _vm._v(" "),
                                          _c("td", [
                                            _vm._v(_vm._s(prep.to_move)),
                                          ]),
                                          _vm._v(" "),
                                          _c("td", [
                                            _c(
                                              "button",
                                              {
                                                staticClass:
                                                  "btn btn-sm btn-success",
                                                attrs: { type: "button" },
                                                on: {
                                                  click: function ($event) {
                                                    return _vm.updateQuantity(
                                                      $event,
                                                      task.taskId
                                                    )
                                                  },
                                                },
                                              },
                                              [
                                                _vm._v(
                                                  "\n                      Выполнено\n                    "
                                                ),
                                              ]
                                            ),
                                          ]),
                                        ])
                                      }
                                    )
                                  }),
                                ],
                                2
                              ),
                            ]),
                          ]),
                        ])
                      : _vm._e(),
                  ])
                }),
                0
              )
            : _c("div", { staticClass: "row" }, [_vm._m(1)]),
        ])
      : _vm._e(),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("thead", [
      _c("tr", [
        _c("th"),
        _vm._v(" "),
        _c("th", [_vm._v("ID")]),
        _vm._v(" "),
        _c("th", [_vm._v("PREP ID")]),
        _vm._v(" "),
        _c("th", [_vm._v("Препарат")]),
        _vm._v(" "),
        _c("th", [_vm._v("количество")]),
        _vm._v(" "),
        _c("th"),
      ]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "col-md-12" }, [
      _c("div", { staticClass: "card" }, [
        _c("div", { staticClass: "card-body text-center" }, [
          _c("h5", [_vm._v("Нет задач для обновления рюкзаков")]),
        ]),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }